



























































import { Component, Vue } from "vue-property-decorator";
import Video from "@/components/Video.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Video,
    BIcon,
    BIconBoxArrowRight,
    Header,
    Menu,
    NextPrevBtn,
    Footer
  }
})
export default class CVVideo extends Vue {
  protected videoCVVideo = [
    {
      videoSrc: "https://www.youtube.com/embed/Ohiv5xhJB9g",
      videoTitle: "CV vidéo Lilian Guinebretière BUT GEII",
      videoRoot: "Chaîne :  Peggy Raffy-Hideux Communication"
    },
    {
      videoSrc: "https://www.youtube.com/embed/Fz6bZaPzPuw",
      videoTitle: "Le film d'animation - Dai Duong Tran",
      videoRoot: "Chaîne :  Dai Duong Tran"
    },
    {
      videoSrc: "https://www.youtube.com/embed/SHY3Etcag4w",
      videoTitle: "Génialement simple - Cristina Castro",
      videoRoot: "Chaîne :   Cristina Castro"
    },
    {
      videoSrc: "https://www.youtube.com/embed/0OyPyRkwszs",
      videoTitle: "Agréable à lire - Patrice Co",
      videoRoot: "Chaîne : Patrice Co"
    },
    {
      videoSrc: "https://www.youtube.com/embed/OPMZoS1CcAI",
      videoTitle: "cerveau disponible Edouard PRIET",
      videoRoot: "Chaîne :  edouard priet"
    },
    {
      videoSrc: "https://www.youtube.com/embed/1SkeJ5fzk6Q",
      videoTitle: "CV Jean-Benoist Werth",
      videoRoot: "Chaîne :   Jean-Benoist Werth"
    },
    {
      videoSrc: "https://www.youtube.com/embed/ZusmOZ65NPs",
      videoTitle: "CV vidéo Sophie Garrigues",
      videoRoot: "Chaîne : sophie"
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x72m5n",
      videoTitle: "Charlotte Ruault CV",
      videoRoot: "Chaîne :  krakotte_53"
    }
  ];
  protected nxtprevCVVideo = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail3.png",
    NextImage: "/thumbnail5.png",
    PrevLink: "/CV/Outils",
    NextLink: "/CV/Aller_Plus_Loin"
  };
}
